module.exports = __webpack_public_path__ + "static/media/prev.335e71f2.svg";